var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-snackbar",
    {
      attrs: { top: "", timeout: _vm.timeout, vertical: "" },
      scopedSlots: _vm._u([
        {
          key: "action",
          fn: function (ref) {
            var attrs = ref.attrs
            return [
              _c(
                "v-container",
                { attrs: { fluid: "" } },
                [
                  _c(
                    "v-row",
                    {
                      staticClass: "mr-1",
                      attrs: { justify: "space-between" },
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", text: "" },
                          on: { click: _vm.cancelClicked },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.cancelText) +
                              "\n                "
                          ),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "v-btn",
                        {
                          attrs: { dark: "", text: "" },
                          on: { click: _vm.acceptClicked },
                        },
                        [
                          _vm._v(
                            "\n                    " +
                              _vm._s(_vm.acceptText) +
                              "\n                "
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]
          },
        },
      ]),
      model: {
        value: _vm.showSnackbar,
        callback: function ($$v) {
          _vm.showSnackbar = $$v
        },
        expression: "showSnackbar",
      },
    },
    [_c("div", { domProps: { innerHTML: _vm._s(_vm.text) } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }